import { css } from '@emotion/react';
import { Stack, Typography } from '@mui/material';
import { ModalFormWidth } from '../constants/styles';
import { FormLabelText } from './Form/FormComponents';

export const AuditContainerCss = css`
  display: grid;
  gap: 1rem;
  min-width: ${ModalFormWidth};
  max-width: 95dvw;
  margin: 0 2.5rem 2rem;
`;

export function AuditItem({ label, value }: { label: string; value: string }) {
  return (
    <Stack gap={2}>
      <FormLabelText label={label} />
      <Typography variant='body2'>{value || '-'}</Typography>
    </Stack>
  );
}
